<template>
    <div class="card-buttons">
        <div class="card-btn__copy"  v-if="genericMessage" v-html="genericMessage">
            Join SK Club now to activate your SK Club
            Standard Bank 4for3 Benefit.
        </div>
        <div class="card-btn__copy" v-if="moreInfoLink">
            <sk-button secondary block tag="a" :href="moreInfoLink" target="_blank">More Info</sk-button>
        </div>
        <div class="card-btn__copy" v-if="activationLink">
            <sk-button secondary block tag="a" :href="activationLink" target="_blank">Activate
            </sk-button>
        </div>
    </div>
</template>

<script type="application/javascript">
    import cardMixin from './cardMixin'
    export default{
        name:'card-discovery',
        mixins:[cardMixin],

    }
</script>


// WEBPACK FOOTER //
// card-generic.vue?4d1ed168